import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./StockItem.css";

const StockItem = (props) => {

  let {data} = props;
  let hasIncoming = data.get("incoming") > 0;

  let classes = cx({
    "item": true,
    "inventory-stock-list-item": true,
    "u-hilight": hasIncoming,
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-sku">{data.get("productSku")}</td>
      <td className="field">{data.get("productTitle")}</td>
      <td className="field f-quantity">{data.get("qoh")}</td>
      <td className="field f-quantity">{data.get("reserved")}</td>
      <td className="field f-quantity">{data.get("atp")}</td>
      <td className="field f-quantity f-incoming">{hasIncoming ? `+${data.get("incoming")}` : 0}</td>
    </tr>
  )
}

export default StockItem;